$(document).ready(function () {

  // Product template -> Upsell function
  $('.product-upsell-list .product-form__variants').change(function () {
    var selected_variant = $(this).find('option:selected').val();
    $(this).closest('.product-upsell-cell').find('input.jq-upsell').attr('data-id', selected_variant);

  });
  $(document).on('click', '.product__info-wrapper .product-form__buttons .product-form__submit', function() {
    var $parentwrapper = $(this).closest('.product__info-wrapper');
    var $addToCartBtn = $parentwrapper.find('.product-form__buttons .product-form__submit');
    var i = 0;
    var items = [];

    if($parentwrapper.find('.product-upsell-list').length > 0){
      $.each($parentwrapper.find('.product-upsell-cell'), function(){
        var $input = $(this).find('input.jq-upsell');
        var variant_id = $input.data('id');
        var variant_quantity = $(this).find('quantity-input input').val();

        if($input.prop('checked')){
          var item = {
            quantity: variant_quantity,
            id: variant_id
          };
          items.push(item);

          i++;
        }
      });
    }
    if(items.length > 0){
      // First-touch merge: give each item either the properties of its
      // already-existing cart line (so the add merges into that line
      // instead of splitting it) or a fresh attribution tag if this is a
      // new line. Read is synchronous (async:false) to match this file's
      // existing style; if it fails, cartData stays null and every item
      // just falls through to a fresh tag below, so a broken read never
      // blocks the add.
      var cartData = null;
      try {
        $.ajax({
          type: 'GET',
          url: '/cart.js',
          async: false,
          dataType: 'json',
          success: function (data) { cartData = data; }
        });
      } catch (e) {}

      var upsellPagePath = (location.pathname || '').slice(0, 120);
      for (var j = 0; j < items.length; j++) {
        var matchedProperties;
        var matchedLine = false;
        if (cartData && cartData.items) {
          for (var m = 0; m < cartData.items.length; m++) {
            if (Number(cartData.items[m].variant_id) === Number(items[j].id)) {
              matchedProperties = cartData.items[m].properties;
              matchedLine = true;
              break;
            }
          }
        }
        if (matchedLine) {
          // null (propertyless line) is left off items[j] entirely so the
          // add matches the existing line exactly.
          if (matchedProperties !== null && matchedProperties !== undefined) {
            items[j].properties = matchedProperties;
          }
        } else {
          items[j].properties = { _mb_source: 'upsell-legacy', _mb_page: upsellPagePath };
        }
      }

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        async: false,
        data: {
          items: items
        },
        dataType: 'json',
        error: function(data) {
          console.log('product unavailable');
        },
        success: function (data) {
          console.log('Checked Upsell Successfully!');
          // Log each item as an event on the hidden _mb_adds cart attribute,
          // mirroring mb-buy-card.js, so legacy adds stay attributable while
          // identical variants merge into one cart line.
          try {
            var pagePath = (location.pathname || '').slice(0, 120);
            $.getJSON('/cart.js', function (cart) {
              var log = (cart.attributes && cart.attributes._mb_adds) || '';
              for (var k = 0; k < items.length; k++) {
                var entry = 'upsell-legacy:' + pagePath + ':' + items[k].id + ':' + items[k].quantity;
                log = log ? log + '|' + entry : entry;
              }
              while (log.length > 900 && log.indexOf('|') !== -1) {
                log = log.slice(log.indexOf('|') + 1);
              }
              $.post('/cart/update.js', { attributes: { _mb_adds: log } });
            });
          } catch (e) {}
          // Mirror of the events the new row fires, so GA4 and Clarity stay
          // comparable when the Upsell layout setting is toggled.
          try {
            if (typeof window.gtag === 'function') {
              window.gtag('event', 'upsell_legacy_add_to_cart', { items_count: items.length });
            } else if (window.dataLayer && typeof window.dataLayer.push === 'function') {
              window.dataLayer.push({ event: 'upsell_legacy_add_to_cart', items_count: items.length });
            }
            if (typeof window.clarity === 'function') {
              window.clarity('event', 'upsell_legacy_add_to_cart');
            }
          } catch (e) { /* analytics must never break the cart */ }
        },
        cache: false
      });
    }
  });

});

